import { Alert } from 'avo-ui'
import { VideoSection } from 'components/award/nomination/video-section/VideoSection'
import { useValidation } from 'hooks/useValidation'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    title_image_url: null,
    description: null,
    video_url: null,
    desktop_background: null,
    mobile_background: null,
}

const VALIDATION = {
    desktop_background: {
        required: 'Background desktop wajib diisi',
    },
    mobile_background: {
        required: 'Background mobile wajib diisi',
    },
    title_image_url: {
        required: 'Image title wajib diisi',
    },
    video_url: {
        required: 'Video URL wajib diisi',
    },
}

export const VideoSectionContainer = () => {
    const [videoDetail, setVideoDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getVideo, isLoading } = useFetch(API_AWARD.NOMINATION_VIDEO)
    const { fetching: updateVideo, isLoading: isUpdating } = useFetch({
        ...API_AWARD.NOMINATION_VIDEO,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)
    const { errorForm, validateForm } = useValidation({ form: videoDetail, schema: VALIDATION })

    useEffect(() => {
        fetchVideo()
    }, [])

    const fetchVideo = async () => {
        const response = await getVideo()
        setVideoDetail(response?.data)
    }
    const onChangeForm = (e) => {
        const { name, value } = e
        setVideoDetail({ ...videoDetail, [name]: value })
    }

    const handleUploadImage = async (files) => {
        let newFormImage = {}
        const fileNames = Object.entries(files).map(([key, item]) => item.name)

        const s3Urls = await getURLImage({ files: fileNames })
        const newEntries = Object.entries(files).map(([key, item], index) => {
            return [key, { ...item, ...s3Urls?.data?.[index] }]
        })

        const s3UrlsWithKey = Object.fromEntries(newEntries)
        await Promise.all(
            Object.entries(s3UrlsWithKey).map(async ([key, item], index) => {
                await uploadFileToS3(item, item.file)
                newFormImage = {
                    ...newFormImage,
                    [key]: `${s3UrlsWithKey?.[key]?.url}${s3UrlsWithKey?.[key]?.fields?.key}`,
                }
            }),
        )
        return newFormImage
    }

    const onSubmit = async () => {
        await validateForm()
        let files = {}
        if (videoDetail?.desktop_background?.file)
            files = { ...files, desktop_background: videoDetail?.desktop_background }
        if (videoDetail?.mobile_background?.file)
            files = { ...files, mobile_background: videoDetail?.mobile_background }
        if (videoDetail?.title_image_url?.file) files = { ...files, title_image_url: videoDetail?.title_image_url }

        let payload = { ...videoDetail }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            payload = {
                ...payload,
                ...(await handleUploadImage(files)),
            }
            setLoadingUpload(false)
        }
        await updateVideo(payload)
        await fetchVideo()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Video Section Updated!',
        })
    }

    const props = {
        data: videoDetail,
        onChangeForm,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <VideoSection {...props} />
}
